module.exports = __webpack_public_path__ + "img/ibm.1ea5dd87.svg";